import '.l{display:grid;}.ssr-plugin'
import '.hc{grid-template-columns:repeat(2, minmax(250px, 1fr));}.ssr-plugin'
import '.a0{gap:1rem;}.ssr-plugin'
import { useMemo } from 'react'
import { useTranslations } from '@i18n/useLanguage'
import { pages } from '@app/util/links'
import { styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'
import { BlogCard } from '@app/components/blocks/card/BlogCard'
import Column from '@app/components/layout/Column'
import { StoredImage } from '@app/types/StoredImage'

export type ArticleContentItem = {
  id: number
  slug: string
  title: string
  intro?: string
  category?: string
  publishedAt?: number
  images?: StoredImage[]
}

type LabeledItem = ArticleContentItem & { type: 'stories' | 'news' | 'blog' }

export type ArticleSectionProps = {
  stories?: ArticleContentItem[]
  news?: ArticleContentItem[]
  blogs?: ArticleContentItem[]
}

export const ArticleSection = ({
  stories = [],
  news = [],
  blogs = [],
}: ArticleSectionProps) => {
  const t = useTranslations().app.blogPage

  const allItems: LabeledItem[] = useMemo(
    () =>
      [
        ...stories.map((item) => ({ ...item, type: 'stories' as const })),
        ...news.map((item) => ({ ...item, type: 'news' as const })),
        ...blogs.map((item) => ({ ...item, type: 'blog' as const })),
      ].sort((a, b) => (b.publishedAt ?? 0) - (a.publishedAt ?? 0)),
    [stories, news, blogs],
  )

  if (allItems.length === 0) {
    return (
      <Column gap="0.5rem">
        <Title.H4>{t.title}</Title.H4>
        <Text.Medium style={{ color: 'var(--gray-300)' }}>
          {t.noContent}
        </Text.Medium>
      </Column>
    )
  }

  return (
    <Column gap="0.5rem">
      <Title.H4>{t.title}</Title.H4>
      <styled.div className="l hc a0"
        style={{
          '@media (max-width: 1200px)': {
            gridTemplateColumns: 'repeat(1, minmax(250px, 1fr))',
          },}}
      >
        {allItems.map((item) => (
          <BlogCard
            key={`${item.type}-${item.id}`}
            title={item.title}
            meta={t.tabs[item.type]}
            image={item.images?.[0]}
            intro={item.intro}
            to={pages.blog(item.type, item.slug)}
          />
        ))}
      </styled.div>
    </Column>
  )
}
